import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Text, Button, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

import PhotoGrid from '../PhotoGrid';

class AddSupportingDocs extends PureComponent {
    state = {
        photos: this.props.supportingPhotos || []
    };

    _selectPicture = (files) => {
        const file = new File([ files[0] ], helpers.cleanFilename(files[0].path), { type: files[0].type });
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = async () => {
            await this.setState({
                photos: [ ...this.state.photos, {
                    file,
                    image: reader.result
                }]
            });

            this.props.saveData([ ...this.state.photos ], 'supportingPhotos');
        };
    };

    _removeImage = (index) => {
        const remove = window.confirm(i18n.t(tokens.labels.claims.removeImageFromSupportingDocs));

        if (!remove) {
            return;
        }

        this.setState({
            photos: this.state.photos.filter((item, i) => i !== index)
        });

        this.props.saveData([ ...this.state.photos ], 'supportingPhotos');
    };

    render() {
        const { next } = this.props;

        const styles = {
            container: {
                display: 'flex',
                flex: 1,
                height: '100%',
                flexDirection: 'column',
                marginBottom: 5
            },
            details: {
                display: 'flex',
                flex: 1,
                overflow: 'auto',
                flexDirection: 'column',
                marginBottom: 20,
                alignItems: 'center'
            }
        };

        return (
            <div style={ styles.container}>
                <div style={ styles.details}>
                    <Text light mediumLarge margin="10px 0 20px 0">
                        {
                            this.props.type === 'HealthSpending' ?
                                i18n.t(tokens.labels.claims.provideOtherDocuments)
                                :
                                i18n.t(tokens.labels.claims.claimAlreadySubmittedToOtherInsurer)
                        }
                    </Text>

                    {
                        this.state.photos.length > 0 &&
                            <PhotoGrid
                                photos={this.state.photos}
                                onPressImage={this._removeImage}
                            />
                    }

                    <Dropzone
                        onDrop={(files) => this._selectPicture(files)}
                        accept={{ 
                            "image/png": [ ".png" ],
                            "image/jpeg": [ ".jpeg" ],
                            "image/jpg": [ ".jpg" ],
                            "application/pdf": [ ".pdf" ] 
                        }}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div id="dropzone" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button
                                        marginTop={ 2 }
                                        marginBottom={ 2 }
                                        transparent
                                    >
                                        { i18n.t(tokens.buttons["select document"]) }
                                    </Button>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                </div>

                <Text light tiny>
                    { i18n.t(tokens.labels.claims.claimAgreementScreen2) }
                </Text>

                <Button
                    onClick={next}
                    marginTop={ 2 }
                    color="primary"
                    fullWidth
                    testid="supportingdocnext"
                >
                    { i18n.t(tokens.buttons.next) }
                </Button>
            </div>
        );
    }
}

export default connect()(AddSupportingDocs);